export default __webpack_public_path__ + "static/media/nutrición_parenteral_neo.54f22c9e.pdf";